import type { JSX } from 'react';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';

export function BariPreMedConsultPlanAppointmentRead(): JSX.Element {
    return <ReadForm />;
}
